import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-inner-box',
    templateUrl: './inner-box.component.html',
    styleUrls: ['./inner-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InnerBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
